/* global FeatureWidget */
import _ from 'lodash';

export default function PlansMeta(data) {
  this.plans = data.plans;
}

PlansMeta.prototype.getPlan = function(name) {
  return _.find(this.plans.models, plan => plan.plan === name);
};

PlansMeta.prototype.getUserLimit = function(plan) {
  return this.getPlan(plan).findPlanFeatureByKey('users_count').getUserLimit();
};

PlansMeta.prototype.getFeatureProp = function(plan, feature, prop) {
  let value = (this.getPlan(plan).findPlanFeatureByKey(feature) || {})[prop];

  if (value === Infinity) {
    value = 'Unlimited';
  }

  return value;
};

PlansMeta.load = function() {
  return new PlansMeta({ plans: new FeatureWidget().plans });
};



// WEBPACK FOOTER //
// ./src/pages/pricing/models/plans-meta.js